import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const TriangleWarning = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M12 16.95a.92.92 0 0 0 .677-.274.92.92 0 0 0 .273-.676.92.92 0 0 0-.274-.677.92.92 0 0 0-.676-.273.92.92 0 0 0-.677.273.92.92 0 0 0-.273.677q0 .402.273.677a.9.9 0 0 0 .677.273m0-2.85a.92.92 0 0 0 .677-.274.92.92 0 0 0 .273-.676V10.3a.92.92 0 0 0-.274-.676A.92.92 0 0 0 12 9.35a.9.9 0 0 0-.677.274.92.92 0 0 0-.273.676v2.85q0 .404.273.677A.92.92 0 0 0 12 14.1"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.19 19.8a.92.92 0 0 1-.807-.475 1.04 1.04 0 0 1-.131-.464.86.86 0 0 1 .13-.487l8.787-15.199a.93.93 0 0 1 .368-.356A1 1 0 0 1 12 2.7a1 1 0 0 1 .464.119.9.9 0 0 1 .367.356l8.787 15.2q.143.237.132.487-.012.249-.132.462a.95.95 0 0 1-.332.345.87.87 0 0 1-.475.13z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(TriangleWarning) as SvgIcon;
export { ForwardRef as ReactComponent };
